import AppConstants from 'constants/AppConstants';

const initialState = {
  jobsInProgress: false,
  jobsSubmitted: 0,
  jobsCompleted: 0,
  jobsFailed: 0,
  showJobProgress: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.NETWORK_PRINTERS_SUBMIT: {
      return {
        ...state,
        jobsInProgress: true,
        jobsSubmitted: payload.length,
        jobsCompleted: 0,
        jobsFailed: 0,
        showJobProgress: true,
      };
    }

    case AppConstants.NETWORK_PRINTERS_SUBMIT_DONE:
    case AppConstants.NETWORK_PRINTERS_SUBMIT_FAILED: {
      return {
        ...state,
        jobsInProgress: false,
        jobsSubmitted: 0,
        jobsCompleted: 0,
        jobsFailed: 0,
        showJobProgress: false,
      };
    }

    case AppConstants.NETWORK_PRINTERS_JOB_STARTING: {
      return state;
    }

    case AppConstants.NETWORK_PRINTERS_JOB_DONE: {
      return {
        ...state,
        jobsCompleted: state.jobsCompleted + 1,
      };
    }

    case AppConstants.NETWORK_PRINTERS_JOB_FAILED: {
      return {
        ...state,
        jobsFailed: state.jobsFailed + 1,
      };
    }

    case AppConstants.NETWORK_PRINTERS_DO_NOT_SHOW_PROGRESS: {
      return {
        ...state,
        showJobProgress: false,
      };
    }

    default:
      return state;
  }
}
